import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Input, Tabs, Typography} from 'antd';

import {TeamOutlined} from '@/icons';
import UserTabPane from './tabPane/UserTabPane';
import DepartTabPane from '@/page/admin/ReportLinePage/ReportLineUserSelector/tabPane/DepartTabPane';

const TABS = {
    userTab: {key: 'userTab', tab: '员工', icon: <TeamOutlined />, component: UserTabPane},
};

export default function MainPanel({
    showUserTab = true,
    allowDepartIds,
    onAddSelected,
    selectUserId,
    selectedDeparts,
}) {
    const tabs = [];

    if (showUserTab) {
        tabs.push(TABS.userTab);
    }

    // const [activeKey, setActiveKey] = useState(tabs[0].key);

    // 用于记录输入时查询框的值
    const [searchValue, setSearchValue] = useState(null);
    // 用于记录查询框最终值，之所以分为 2 个，是为了防止输入时候随时查询
    const [finalSearchValue, setFinalSearchValue] = useState(null);

    function onSearchChange(e) {
        setSearchValue(e.target.value);
    }

    function onSearch(value) {
        setFinalSearchValue(value);
    }

    function clearSearchValue() {
        setSearchValue(null);
        setFinalSearchValue(null);
    }

    function getExtraProps(key) {
        if (key === 'userTab') {
            return {
                departIds: allowDepartIds,
                searchValue: finalSearchValue,
                clearSearchValue,
                parentUserId: selectUserId,
            };
        }
        if (key === 'departTab') {
            return {
                selectedDeparts: selectedDeparts,
            };
        }
    }

    function renderSearch() {
        let placeholder = '按员工编号、姓名查询';
        return (
            <Input.Search
                allowClear
                style={{width: 300}}
                placeholder={placeholder}
                value={searchValue}
                onChange={onSearchChange}
                onSearch={onSearch}
            />
        );
    }

    return (
        <div style={{flex: 'auto', flexDirection: 'row'}}>
            <Tabs defaultActiveKey="1">
                <Tabs.TabPane tab="用户列表" key="1">
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16}}>
                        <div></div>
                        <div>
                            {renderSearch()}
                        </div>
                    </div>
                    <UserTabPane onAddSelected={onAddSelected} {...getExtraProps('userTab')} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="部门列表" key="2">
                    <Typography.Title level={4} style={{marginBottom: 16}}></Typography.Title>
                    <DepartTabPane
                        onAddSelected={onAddSelected}
                        checkable={true}
                        {...getExtraProps('departTab')}
                    />
                </Tabs.TabPane>
            </Tabs>
        </div>
    );
}

MainPanel.propTypes = {
    /**
     * 是否显示部门选择 tab
     */
    showDepartTab: PropTypes.bool,

    /**
     * 是否显示人员选择 tab
     */
    showUserTab: PropTypes.bool,

    /**
     * 是否显示标签选择 tab
     */
    showTagTab: PropTypes.bool,

    /**
     * 可见的部门 id
     *
     * 如果为为 null 或 undefined, 表示所有部门可见
     *
     * 如果是 [] ，表示所有不可见
     * 如果有值，则对应部门和子部门可见
     */
    allowDepartIds: PropTypes.arrayOf(PropTypes.string),

    allowUsers: PropTypes.array,

    onAddSelected: PropTypes.func.isRequired,
};
